// @flow

import React, {useState} from "react";
import {Popconfirm, Input, Form} from "antd";
import {MailOutlined, ApiOutlined} from "@ant-design/icons";
import {apiIntegrationMailPopconfirmPropTypes} from "./ApiIntegrationMailPopconfirmPropTypes";
import {CustomButton} from "../../../../_defaultComponents/CustomButton/CustomButton";
import {useTranslation} from "react-i18next";
import {apiIntegrationMailFormValidations} from "./ApiIntegrationMailFormValidations";
import stores from "../../../../../store/stores";

export const ApiIntegrationMailPopconfirm = ({
    companyData
}: apiIntegrationMailPopconfirmPropTypes) => {
    const [apiIntegrationDeveloperEmail, setApiIntegrationDeveloperEmail] = useState("");
    const {t} = useTranslation();
    const isApiIntegrationActive = Boolean(companyData?.isApiIntegrationActive);
    const submitForm = async () => {
        try {
            const emailAddress = apiIntegrationDeveloperEmail;
            const params = {emailAddress, companyId: companyData._id};
            await apiIntegrationMailFormValidations.validate(params);
            const result = await stores.companyStore.sendApiGuidelineEmail(params);
            if (!result.isSent) {
                stores.appStore.openErrorModal({
                    title: t("modal.errorTitle", {ns: "common"}),
                    content: t("stores.company.sendApiGuidelineEmail.errorMessage", {
                        ns: "common",
                        errorMessage: result.error
                    })
                });
            } else if (result.isSent.rejected.length > 0) {
                stores.appStore.openWarningModal({
                    title: t("modal.warningTitle", {ns: "common"}),
                    content: t("stores.company.sendApiGuidelineEmail.failedMessage", {
                        ns: "common",
                        emailAddress
                    })
                });
            } else if (result.isSent.accepted.length > 0) {
                stores.appStore.openSuccessModal({
                    title: t("modal.successfulTitle", {ns: "common"}),
                    content: t("stores.company.sendApiGuidelineEmail.successMessage", {
                        ns: "common",
                        emailAddress
                    })
                });
            } else {
                stores.appStore.openErrorModal({
                    title: t("modal.errorTitle", {ns: "common"}),
                    content: t("errorMessages.AnUnexpectedErrorHasOccurred", {
                        ns: "common"
                    })
                });
            }
            setApiIntegrationDeveloperEmail("");
        } catch (error) {
            let errorMessage =
                error?.message ||
                t("errorMessages.AnUnknownErrorWasOccurred", {
                    ns: "common"
                });
            if (error?.errors?.length > 0) {
                errorMessage = error.errors.join("\n");
            }
            stores.appStore.openErrorModal({content: errorMessage});
        }
    };

    const handleChange = e => {
        setApiIntegrationDeveloperEmail(e.target.value);
    };

    const renderForm = () => {
        return (
            <Form
                autoComplete="off"
                labelCol={{span: 24}}
                wrapperCol={{span: 24}}
                style={{marginLeft: "-20px"}}
            >
                <Form.Item label={t("fields.email", {ns: "common"})}>
                    <Input
                        prefix={<MailOutlined className="site-form-item-icon" />}
                        name="emailAddress"
                        value={apiIntegrationDeveloperEmail}
                        onChange={handleChange}
                        data-testid="apiIntegrationGuidelineMailAddress"
                    />
                </Form.Item>
            </Form>
        );
    };
    return (
        <Popconfirm
            placement="topRight"
            icon={<></>}
            title={renderForm}
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={submitForm}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {
                ns: "common"
            })}
        >
            <CustomButton
                type="ghost"
                data-testid="sendApiIntegrationMailButton"
                disabled={!isApiIntegrationActive}
                icon={<ApiOutlined />}
            >
                {t("fields.sendApiImplementationDirectives", {
                    ns: "common"
                })}
            </CustomButton>
        </Popconfirm>
    );
};
